import { useEffect, useState } from 'react'

import axios from 'axios'

import { RGIconComponent } from './icons/RgIconComponent'
import { CnhIconComponent } from './icons/CnhIconComponent'
import { OthersIconComponent } from './icons/OthersIconComponent'
import { CnhDigitalIconComponent } from './icons/CnhDigitalIconComponent'
import { PassportIconComponent } from './icons/PassportIconComponent'
import { CtpsIconComponent } from './icons/CtpsIconComponent'
import { RneIconComponent } from './icons/RneIconComponent'

import { ErrorPage } from "../ErrorPage"
import { LoadingPage } from '../LoadingPage'
import { getColorContrast } from '../../utils/helpers'
import PoweredbByQITech from '../../components/PoweredByQITech'
import ClientLogo from '../../components/ClientLogo'
import * as G from '../../theme/global-styles'
import * as S from './styles'

import { Wallpaper } from '../../components/Wallpaper';
import { Box } from '@mui/material';
import Logo from '../../components/Logo';
import { Footer } from '../../components/Footer';
import { PersonalDocumentConfirmation } from '../PersonalDocument/personalDocumentConfirmation'
import { CollectImageTitle, DocumentIcon, DocumentText } from './styles'
import { setDatadogError } from 'src/services/datadog'
import { useThemeContext } from "../../contexts/ThemeContext";
import { ThemedButton } from 'src/components/ThemedButton'
import { getOrCreateBrowserKey } from '../../utils/fingerprint_utils'

export const PersonalDocument = (props) => {
    const { clientThemeSettings } = useThemeContext();

    const { signData, setSignerStep, setSignData, appTheme } = props
    const initialError = {"has_error": false, "status": 0}

    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [hasMadeRequest, setHasMadeRequest] = useState(false)

    const documentTemplates = {
        rg: {
          icon: RGIconComponent,
          title: 'Cédula de Identidade (RG/CIN)',
          fileType: 'svg'
        },
        cnh: {
          icon: CnhIconComponent,
          title: 'Carteira de Habilitação (CNH)',
          fileType: 'svg'
        },
        cnh_digital: {
          icon: CnhDigitalIconComponent,
          title: 'Carteira de Habilitação Digital (CNH)',
          fileType: 'svg'
        },
        rg_cin_digital: {
          icon: CnhDigitalIconComponent,
          title: 'Cédula de Identidade Digital (RG/CIN)',
          fileType: 'svg'
        },
        cin_digital: {
          icon: RGIconComponent,
          title: 'Carteira de Identidade Nacional (CIN)',
          fileType: 'svg'
        },
        passport: {
          icon: PassportIconComponent,
          title: 'Passaporte',
          fileType: 'svg'
        },
        rne: {
          icon: RneIconComponent,
          title: 'Registro Nacional de Estrangeiros (RNE)',
          fileType: 'svg'
        },
        crnm: {
          icon: RneIconComponent,
          title: 'Carteira de Registro Nacional Migratório (CRNM)',
          fileType: 'svg'
        },
        ctps: {
          icon: CtpsIconComponent,
          title: 'Carteira de Trabalho e Previdência Social (CTPS)',
          fileType: 'svg'
        },
        others: {
          icon: OthersIconComponent,
          title: 'Outros Documentos',
          fileType: 'svg'
        }
      }

    const defaultClientDocumentTemplates = [
        'rg',
        'cnh'
    ]
    
    const clientDocumentTemplates = (signData.document_templates !== undefined && signData.document_templates !== null)
        ? signData.document_templates
        : defaultClientDocumentTemplates;


    useEffect(() => {
        setLoading(false)
    }, [])

    if (loading) {
        return (
            <LoadingPage clientThemeSettings={clientThemeSettings} />
        )
    }

    var htmlComponent = document.getElementById('root')

    var webOCR = new window.QiTechWebOCR.WebOCR(
        htmlComponent,
        signData.ocr_token,
        signData.session_id
    )
    .setThemeConfiguration(
        {
            "companyLogo": clientThemeSettings["logo_url"],
            "backgroundColor": clientThemeSettings["background_color"],
            "buttonColor": clientThemeSettings["button_color"],
            "buttonFontColor": getColorContrast(clientThemeSettings["button_color"]),
            "modalBackgroundColor": "#F5F5F2",
            "fontColor": "#334150"
        }
    )
    .setShowInstructionScreen(true)
    .setShowSuccessScreen(false)
    .setShowAllowedTemplatesScreen(false)

    process.env.REACT_APP_ENV === 'production' ? webOCR.build() : webOCR.setSandboxEnvironment().build()

    function initOCR(document_types) {    
        webOCR.initialize(document_types)
        .then((ocr_key) => {
            submitOCRKeys(ocr_key)
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const submitOCRKeys = async (ocrKeys) => {

        if (hasMadeRequest) {
            return  
        }

        let payload
        if(ocrKeys.length === 1){
            const ocrKey = ocrKeys[0]['ocr_key']

            payload = {
                "ocr_full_document_key": ocrKey
            }
        }
        else if (ocrKeys.length === 2){
            const firstOcrKey  = ocrKeys[0]
            const secondOcrKey = ocrKeys[1]

            const firstDocumentArray = firstOcrKey['template'].split('_')
            const ocrFrontKey = firstDocumentArray[firstDocumentArray.length - 1]  === 'front' ? firstOcrKey['ocr_key'] : secondOcrKey['ocr_key']
            const ocrBackKey  = firstDocumentArray[firstDocumentArray.length - 1]  === 'back' ? firstOcrKey['ocr_key'] : secondOcrKey['ocr_key']

            payload = {
                "ocr_front_key": ocrFrontKey,
                "ocr_back_key": ocrBackKey
            }
        }
        else {
            setDatadogError("Unspported ocr key amount", {
                  "ocr_key_amount": ocrKeys.length,
                  "signData": signData
                })
        }
        
        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }
        let browserKey = null;
        try{
            browserKey = await getOrCreateBrowserKey();
        } catch(err) {
        }
        
        payload = { 
            ...payload, 
            "step": "personal_document",
            "event_date": new Date().toISOString(),
            "device_data": {
                "device_key": browserKey
            }
        }

        setLoading(true)
        setHasMadeRequest(true)

        axios.patch('/signer', payload, config)
        .then(response => {
            setSignerStep(response.data.next_step)
            setSignData({ ...signData, ...response.data })
        })
        .catch((error) => {
            if ([401, 403, 409].includes((error.response || {}).status)) {
                setError({
                    "has_error": true,
                    "status": error.response.status
                })
            } else {
                setError({
                    "has_error": true,
                    "status": 500
                })
            }

            setHasMadeRequest(false)
        })
        .finally(() => {
            setLoading(false)
        })
    }

    if (appTheme === 'release') {
        return (
            <S.Container>
                <ClientLogo clientThemeSettings={clientThemeSettings} size="small" />
                <S.PersonalDocumentContainer>
                    <G.Title>Envie seu documento</G.Title>
                    <S.Description>
                        Documentos aceitos:
                    </S.Description>
                    <S.DocumentsGrid>
                        {clientDocumentTemplates.map((type, index) => {
                            const doc = documentTemplates[type]
                            return (
                                <S.DocumentContainer
                                key={index}
                                $primaryColor={'#CCC'}
                                onClick={() => initOCR(clientDocumentTemplates)}
                                >
                                {
                                    doc.fileType === 'png' ? (
                                    <S.DocumentIcon src={doc.icon} alt={type} />
                                    ) : (
                                    <doc.icon
                                        size={doc.size || 36}
                                        fillColor={(clientThemeSettings.button_color || 'FFF') + '33'}
                                        strokeColor={clientThemeSettings.button_color}
                                    />
                                    )
                                }
                                <S.DocumentText >{doc.title}</S.DocumentText>
                                </S.DocumentContainer>
                            )
                        })}
                    </S.DocumentsGrid>
                </S.PersonalDocumentContainer>
                <div style={{width: '80%'}}>
                    <ThemedButton
                        clientThemeSettings={clientThemeSettings}
                        onClick={() => initOCR(clientDocumentTemplates)}
                    >
                        {'Continuar'}
                    </ThemedButton>
                </div>
                <S.Footer>
                    <PoweredbByQITech />
                </S.Footer>
                {error.has_error &&
                    <ErrorPage
                        error={error}
                        redirectToLogin={() => setSignerStep("login")}
                        resetError={() => setError(initialError)}
                        clientThemeSettings={clientThemeSettings}
                    />
                }
            </S.Container>
        )
    }

    return (
        <Wallpaper backgroundColor={clientThemeSettings["background_color"]} style={{ padding: '10px' }}>
            <div className="base-container base-container-width base-container-padding" style={{ backgroundColor: "rgb(245, 245, 242)" }}>
                <Logo imageSource={clientThemeSettings.logo_url} />
                <Box>
                    {(!signData.collect_personal_document) && signData.personal_documents ? (
                        <PersonalDocumentConfirmation clientThemeSettings={clientThemeSettings} signData={signData} setSignerStep={setSignerStep} setSignData={setSignData}/>
                    ) : (
                        <div>
                            <CollectImageTitle>
                                Agora vamos coletar imagens do seu documento. Escolha entre os tipos abaixo:
                            </CollectImageTitle>

                            {clientDocumentTemplates && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>

                                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', width: '100%' }}>
                                    {clientDocumentTemplates.map((type, index) => (

                                        <button
                                            key={index}
                                            onClick={() => initOCR(clientDocumentTemplates)}
                                            style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '10px 15px',
                                            border: '1px solid #ccc',
                                            borderRadius: '5px',
                                            backgroundColor: '#f9f9f9',
                                            outline: 'none',
                                            WebkitTapHighlightColor: 'transparent'
                                            }}
                                            type='primary'
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9e9e9'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
                                            >
                                            <DocumentIcon
                                            src={documentTemplates[type]['icon']}
                                            alt={type}
                                            />
                                            <DocumentText>{documentTemplates[type]['title']}</DocumentText>
                                        </button>
                                    ))}
                                </div>

                            </div>}

                        </div>
                        
                    )}
                </Box>
                <div style={{width: '80%'}}>
                    <ThemedButton
                        clientThemeSettings={clientThemeSettings}
                        onClick={() => initOCR(clientDocumentTemplates)}
                    >
                        {'Continuar'}
                    </ThemedButton>
                </div>
                <Footer />
            </div>
            {error.has_error &&
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerStep("login")}
                    resetError={() => setError(initialError)}
                    clientThemeSettings={clientThemeSettings}
                />
            }
        </Wallpaper>
    )
}